export default __webpack_public_path__ + "static/media/fire153x46.64d3c33f.png";